import { render, staticRenderFns } from "./LocalMenuProductService.vue?vue&type=template&id=4bfd1cb6"
import script from "./LocalMenuProductService.vue?vue&type=script&lang=js"
export * from "./LocalMenuProductService.vue?vue&type=script&lang=js"
import style0 from "./LocalMenuProductService.vue?vue&type=style&index=0&id=4bfd1cb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports